import type { QueryClient } from "@tanstack/react-query";

export const accountIdQueryKey = ["account-id"] as const;
export const myAccountSettingsQueryKey = ["my-account-settings"] as const;
export const myRolesQueryKey = ["my-roles"] as const;
export const navigationQueryKey = ["navigation"] as const;

export function clearAuthenticatedSessionQueries(queryClient: QueryClient) {
  queryClient.clear();
}
